import { VlRouteBase } from '@vuelib/components';

export default /** @type { import('vue-router').RouteConfig } */ ({
  path: 'applications',
  component: VlRouteBase,
  meta: {},
  children: [
    {
      path: '',
      name: 'applicationList',
      component: () => import('@/views/applications/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support', 'company'],
      },
    },
    {
      path: ':id',
      name: 'applicationForm',
      component: () => import('@/views/applications/_id.vue'),
      props: true,
      meta: {
        roles: ['admin', 'developer', 'support', 'company'],
      },
    },
    {
      path: ':applicationId/versions',
      name: 'versionList',
      props: true,
      component: () => import('@/views/applications/versions/index.vue'),
      meta: {
        roles: ['admin', 'developer', 'support', 'company'],
      },
    },
    {
      path: ':applicationId/versions/:id',
      name: 'versionForm',
      component: () => import('@/views/applications/versions/_id.vue'),
      props: true,
      meta: {
        roles: ['admin', 'developer', 'support', 'company'],
      },
    },
  ],
});
